<template>
    <div class="cxxfIndex">
        <Header title="创新学分查看" type="0" route="/homeIndex"></Header>
        <div class="content">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="hdlx" label="活动类型"> </el-table-column>
                <el-table-column prop="hdmc" label="活动名称"> </el-table-column>
                <el-table-column prop="xnxq01id" label="学期"> </el-table-column>
                <el-table-column prop="cxxf" label="学分"> </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { Api } from '@/utils/axios';

export default {
    data() {
        return {
            tableData: []
        };
    },
    created() {
        this.getList();
    },
    methods: {
        async getList() {
            const res = await Api.cxcxxf();
            this.tableData = res.data;
        }
    }
};
</script>

<style lang="less" scoped>
.cxxfIndex {
    .content {
        padding: 0 20px;
    }
}
</style>
<style lang="less">
.cxxfIndex {
    .el-table td {
        border-bottom: 1px solid #ebeef5 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/cxxf/index.vue